import { ChartColumnBig } from 'lucide-react';
import cx from 'classnames';
import './analyticsMarker.css';

/** Marks numbers and filters that correspond to a figure on the analytics dashboard. */
export const AnalyticsMarker = ({
    hint,
    className,
}: {
    hint: string;
    className?: string;
}) => (
    <span
        className={cx('mundu-analytics-marker', className)}
        title={hint}
        aria-label={hint}
        role="img"
    >
        <ChartColumnBig size={12} strokeWidth={2.25} aria-hidden="true" />
    </span>
);
